import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';
import { EDailyrentActionType } from '../../types/dailyrent';
import { TRecommendation } from '../../types/recommendation';
import { ChatButtonContainer } from '../ChatButtonContainer';
import { CardActionsContainer } from '../CardActionsContainer';
import { trackOtaActionButton } from './tracking';

import * as styles from './styles.css';

interface IDailyrentActionButtonsProps {
  offer: TRecommendation;
  position: number;
}

const DailyrentActionButton = ({
  children,
  offerUrl,
  onClick,
}: {
  children: string;
  offerUrl: string;
  onClick?: () => void;
}) => {
  return (
    <LinkButton fullWidth href={offerUrl} size="L" target="_blank" rel="noopener noreferrer" onClick={onClick}>
      {children}
    </LinkButton>
  );
};

export const DailyrentActionButtons = ({ offer, position }: IDailyrentActionButtonsProps) => {
  const { dailyrent } = offer;

  const onOtaActionButtonClick = React.useCallback(() => {
    trackOtaActionButton(offer.offerId, position);
  }, [offer.offerId, position]);

  if (!dailyrent || !dailyrent.actionType) {
    return null;
  }

  const offerUrl = offer.url;

  switch (dailyrent.actionType) {
    case EDailyrentActionType.OtaBooking:
    case EDailyrentActionType.OtaCheckDates:
      return (
        <div className={styles.root}>
          <div className={styles['book-button']}>
            <DailyrentActionButton offerUrl={offerUrl} onClick={onOtaActionButtonClick}>
              Проверить даты
            </DailyrentActionButton>
          </div>

          <ChatButtonContainer offerId={offer.offerId} type="short" />
        </div>
      );

    case EDailyrentActionType.PartnerBooking:
    case EDailyrentActionType.PartnerCheckDates:
      return <DailyrentActionButton offerUrl={offerUrl}>Проверить даты</DailyrentActionButton>;

    case EDailyrentActionType.Chat:
      return <ChatButtonContainer offerId={offer.offerId} />;

    default:
      return <CardActionsContainer offerId={offer.offerId} />;
  }
};
